export const deleteProperty = (target: any, path: string): void => {
	if (!target || typeof target !== 'object') {
		throw new Error('Target must be an object or array.');
	}

	const keys = path.split('.');
	let current = target;

	for (let i = 0; i < keys.length - 1; i++) {
		if (!(keys[i] in current)) return; // Schlüssel existiert nicht
		current = current[keys[i]];
	}

	delete current[keys[keys.length - 1]];
};
